import { LanguageRegular, XStack, ProfileUnFilled, Stack, useTheme } from '@ninjacart/nc-nk-ui';
import { Pressable } from 'react-native';
import { INinjaEvent, useQueuedEventStore } from '@ninjacart/nc-events-sdk-v2';
import { useRef } from 'react';
import { Plus } from '@tamagui/lucide-icons';
import { KissanEventType } from '@ninjacart/nc-nk-store';

interface HeaderActionsProps {
  enableLanguageIcon: boolean;
  appLanguage?: string;
  profileTabLanguageFilter: string[];
  onLanguageChange: () => void;
  onProfileClick: () => void;
  onCreatePost: () => void;
  theme: any;
}

export const HeaderActions = ({
  enableLanguageIcon,
  appLanguage,
  profileTabLanguageFilter,
  onLanguageChange,
  onProfileClick,
  onCreatePost,
  theme,
}: HeaderActionsProps) => {
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;

  return (
    <XStack marginTop={12}>
      <Stack height={42} width={42} marginRight={6} opacity={enableLanguageIcon ? 1 : 0}>
        {enableLanguageIcon ? (
          <Pressable onPress={onLanguageChange}>
            <Stack
              borderRadius={12}
              borderWidth={1}
              borderColor={'$primary'}
              backgroundColor={'$background'}
              padding={8}
              height={42}
              width={42}
            >
              <LanguageRegular size={24} color={theme['primary']?.val} />
            </Stack>
          </Pressable>
        ) : null}
      </Stack>

      <Stack
        height={42}
        width={42}
        marginRight={6}
        opacity={profileTabLanguageFilter.includes(appLanguage ?? '') ? 1 : 0}
      >
        {profileTabLanguageFilter.includes(appLanguage ?? '') && (
          <Pressable onPress={onProfileClick}>
            <Stack
              borderRadius={12}
              borderWidth={1}
              borderColor={'$primary'}
              backgroundColor={'$background'}
              padding={8}
              height={42}
              width={42}
              testID="kisan_tId_ProfileTab"
            >
              <ProfileUnFilled width={30} height={30} color={theme['primary']?.val} />
            </Stack>
          </Pressable>
        )}
      </Stack>

      <Pressable
        onPress={() => {
          const selectCreatePostEvent: INinjaEvent = {
            name: KissanEventType.SELECT_CREATEPOST,
            screenDetails: { screen: 'feed create post page' },
          };
          enqueue(selectCreatePostEvent);
          onCreatePost();
        }}
      >
        <Stack
          testID="kisan_tId_Plus"
          borderRadius={12}
          borderWidth={1}
          borderColor={'$primary'}
          backgroundColor={'$background'}
          padding={8}
          height={42}
          width={42}
        >
          <Plus color={theme['primary']?.val} size={24} />
        </Stack>
      </Pressable>
    </XStack>
  );
};
